<div class="ui-g" [formGroup]="parentForm">
  <div class="ui-g-9">

    <div class="ui-g">
      <div class="ui-g-offset-4 ui-g-8">
        <h3 class="m-t-0">
          {{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.ANNUAL_REPORTING' | translate }}
        </h3>
      </div>
    </div>

    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_ANNUAL_REPORT_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.ANNUAL_REPORT' | translate }}</label>
      </div>
      <div class="ui-g-4">
        <p-dropdown
          [(ngModel)]="annualReportYear"
          [ngModelOptions]="{standalone: true}"
          [options]="annualReportYears">
        </p-dropdown>
      </div>
    </div>

    <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_ANNUAL_REPORT_UPDATE']">
      <div class="ui-g-offset-4 ui-g-8">
        <wsd-add-files
          [accept]="'application/pdf'"
          [multiple]="false"
          [hideUpload]="!annualReportYear"
          [fileName]="'Annual report'"
          [fileType]="fileTypes.ANNUAL_REPORT"
          [files]="fileInfo"
          (uploaded)="annualReportUploaded($event)">
          {{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SUPPORTED_FORMATS_PDF' | translate  }}
        </wsd-add-files>
      </div>
    </div>

    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_ANNUAL_FINANCIAL_STATEMENT_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.ANNUAL_FIN_STATEMENT' | translate }}</label>
      </div>
      <div class="ui-g-4">
        <p-dropdown
          [(ngModel)]="annualStatementYear"
          [ngModelOptions]="{standalone: true}"
          [options]="annualStatementYears">
        </p-dropdown>
      </div>
    </div>

    <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_ANNUAL_FINANCIAL_STATEMENT_UPDATE']">
      <div class="ui-g-offset-4 ui-g-8">
        <wsd-add-files
          [accept]="'application/pdf,.xls,.xlsx'"
          [multiple]="false"
          [hideUpload]="!annualStatementYear"
          [fileName]="'Annual financial report'"
          [fileType]="fileTypes.ANNUAL_FINANCIAL_STATEMENT"
          [files]="fileInfo"
          (uploaded)="annualStatementUploaded($event)">
          {{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SUPPORTED_FORMATS_PDF_XLS' | translate  }}
        </wsd-add-files>
      </div>
    </div>

    <div class="ui-g">
      <div class="ui-g-offset-4 ui-g-8">
        <h3 class="m-t-0">
          {{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SAFE_FROM_HARM' | translate }}
        </h3>
      </div>
    </div>

    <div class="ui-g m-b-5" *gsShowIfHasPermission="['ORGANIZATION_SAFE_FROM_HARM_POLICY_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SFH_POLICY' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <wsd-add-files
          [accept]="'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel, .xls,.xlsx'"
          [fileName]="'Safe from harm policy'"
          [fileType]="fileTypes.SAFE_FROM_HARM_POLICY"
          [files]="fileInfo"
          [hideUpload]="isSfhPolicyPresent()"
          (uploaded)="sfhReportUploaded($event)">
          {{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SFH_FORMAT' | translate  }}
        </wsd-add-files>
      </div>
    </div>

    <div class="ui-g m-b-5" *gsShowIfHasPermission="['ORGANIZATION_SAFE_FROM_HARM_REPORTING_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SFH_MECHANISM' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <wsd-add-files
          [accept]="'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,.xls,.xlsx'"
          [fileName]="'Safe from Harm Procedure'"
          [fileType]="fileTypes.SAFE_FROM_HARM_REPORTING"
          [files]="fileInfo"
          [hideUpload]="isSfhReportPresent()"
          (uploaded)="sfhReportUploaded($event)">
          {{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SFH_FORMAT' | translate  }}
        </wsd-add-files>
      </div>
    </div>

    <div class="ui-g m-b-15" *gsShowIfHasPermission="['ORGANIZATION_SAFE_FROM_HARM_ASSESSMENT_UPDATE']">
      <div class="ui-g-4">
        <label> {{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SAFE_FROM_HARM_DATE' | translate  }}</label>
      </div>
      <div class="ui-g-4">
        <wsd-extended-input [control]="parentForm.get('sfhAssessmentDate')">
        <p-calendar wsdUseUtc [showIcon]="true"
                    dateFormat="dd/mm/yy"
                    formControlName="sfhAssessmentDate">
        </p-calendar>
        </wsd-extended-input>
        <p class="m-b-30 m-t-0" style="white-space: nowrap;">{{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.ASSESSMENT_TOOLTIP' | translate }}</p>
      </div>
    </div>

    <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_SUMMARY_NOTE_READ']">
      <div class="ui-g-offset-4 ui-g-8">
        <h3 class="m-t-0">
          {{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SUMMARY_NOTE' | translate }}
        </h3>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_SUMMARY_NOTE_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SUMMARY_NOTE' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <wsd-add-files
          [accept]="'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
          [editable]="canEditFiles"
          [fileType]="fileTypes.SUMMARY_NOTE"
          [files]="fileInfo">
          {{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.SUPPORTED_FORMATS' | translate  }}
        </wsd-add-files>
      </div>
    </div>
  </div>
</div>
